import { RESUME_LABEL } from "../../constants/Dictionary";
import { Resume } from "../../screens/CollaboratorDetail/CollaborProfileTabs/Resume/Resume";
import { Panel } from "../core/Panel/Panel";
import { useState } from "react";
import { useCollaboratorCmSheets } from "../../hooks/collaboratorProfile.hook";
import { PendingCalibration } from "../CalibrationModal/CalibrationModal";
import { OptionItem, TextSwitch } from "../TextSwitch/TextSwitch";
import { useAppSelector } from "../../hooks/store.hook";
import { useCollaboratorResume } from "../../hooks/collaboratorResume.hook";
import { UpdateCollaboratorResumeRequest } from "../../types/api/collaborators.type";

interface ResumePanelProps {
  collaboratorId: number | null;
  isOpen: boolean;
  onClose: () => void;
  width?: number;
  fullHeight?: boolean;
  readOnly?: boolean;
  pendingCalibration?: PendingCalibration;
  onCalibrationChange?: (x: PendingCalibration | null) => void;
  hideEditButton?: boolean;
  onResumeChange?: (body: UpdateCollaboratorResumeRequest) => void;
  pendingResume?: UpdateCollaboratorResumeRequest;
}

export const ResumePanel = ({
  collaboratorId,
  isOpen,
  onClose,
  width,
  fullHeight,
  readOnly,
  pendingCalibration,
  onCalibrationChange,
  hideEditButton = false,
  onResumeChange,
  pendingResume,
}: ResumePanelProps) => {
  const { config: configYears } = useAppSelector((state) => state.config);

  const { data: resumeData, isFetching: resumeLoading } = useCollaboratorResume(
    collaboratorId,
    isOpen,
  );

  const { data: collaboratorCmSheets, isFetching: cmSheetsLoading } =
    useCollaboratorCmSheets(collaboratorId, isOpen);

  const currentConfigYear = configYears.find((item) => item.current)?.year;

  const [selectedYear, setSelectedYear] = useState<OptionItem<number>>({
    value: currentConfigYear ?? 0,
    label: currentConfigYear?.toString() ?? "",
  });

  const textSwitchOptions = resumeData?.map((item) => ({
    label: item.year.toString(),
    value: item.year,
  }));

  return (
    <Panel
      fullHeight={fullHeight}
      isOpen={isOpen}
      onClose={onClose}
      width={width}
      title={RESUME_LABEL}
      rightComponent={
        textSwitchOptions?.length ? (
          <TextSwitch
            selectedOption={selectedYear}
            setSelectedOption={setSelectedYear}
            options={textSwitchOptions}
          />
        ) : undefined
      }
    >
      {isOpen ? (
        <Resume
          cmSheetsLoading={cmSheetsLoading}
          pendingCalibration={pendingCalibration}
          onCalibrationChange={onCalibrationChange}
          readOnly={readOnly}
          collaboratorCmSheets={collaboratorCmSheets ?? null}
          collaboratorId={collaboratorId}
          hideEditButton={hideEditButton}
          resumeData={resumeData}
          resumeLoading={resumeLoading}
          selectedYear={selectedYear}
          onResumeChange={onResumeChange}
          pendingResume={pendingResume}
        />
      ) : null}
    </Panel>
  );
};
